import { gql } from '@apollo/client'

export const GET_USER = gql`
  query UserQuery($user: String) {
    user(user: $user) {
      firstName
      lastName
      email
      user
      merchant {
        merchantId
        name
      }
      profile {
        menuDetails {
          id
          url
          type
          children {
            id
            url
            type
          }
        }
      }
      provider {
        idProvider
        name
        countryId
      }
    }
  }
`

export const UPDATE_PASSWORD = gql`
  mutation updatePassword($merchantId: String, $fields: PasswordInput) {
    updatePassword(merchantId: $merchantId, fields: $fields) {
      userId
      user
      status
      statusType
    }
  }
`
